import './App.css';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import Home from './page/Home';
import About from './page/About';
import Map from './page/Map';
import { Drawer } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Form from './page/Component/Form';
import HorizontalBars from './page/Component/BarChart';
import PayChart from './page/Component/PayChart';
import axios from 'axios';

function App() {
  const [state, setState] = React.useState(false); // Set initial state to false for Drawer

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState(open); // Correctly update the state
  };
  const [navLocation,SetNavLocation] = React.useState(null);
function navSelected(nav){
SetNavLocation(nav)
setState(true)

}
const [apifeatch, setApifeatch] = useState([]); // Initialize state for API data

   useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://outreach-mapping-tool-1.onrender.com/form/getReachedPeoples');
        setApifeatch(response.data); // Update state with fetched data
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData(); // Call the fetch function
  }, []);
  return (
    <BrowserRouter>
      <div className='relative '>
        <div className=''>
          <Routes>
            <Route index path="/" element={<Map />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </div>
        <div className='absolute top-0 left-0 w-full flex justify-center justify-items-center rounded-md'>
          <header className="w-[80%] py-4 px-6 pt-6 bg-white top-8 fixed rounded-md">
            <div className="max-w-7xl mx-auto flex items-center justify-between">
              <Link to="/" className="text-2xl font-bold text-gray-900">
               Outreach map
              </Link>
              <nav className="hidden md:flex items-center space-x-6">
              <button onClick={()=>navSelected('dashboard')} className="">
                Dashboard 
                </button>
                <Link to="/blogs" className="text-gray-600 hover:text-gray-900">Blogs</Link>
                <Link to="/donate" className="text-gray-600 hover:text-gray-900">Donate</Link>
                <Link to="/about" className="text-gray-600 hover:text-gray-900">About</Link>
                <Link to="/contact" className="text-gray-600 hover:text-gray-900">Contact us</Link>
                <Link to="/signin" className="text-gray-600 hover:text-gray-900">Sign in</Link>
                <button onClick={()=>navSelected('add')} className="px-4 py-2 bg-gray-900 text-white rounded hover:bg-gray-800 transition-colors">
                  Add Data
                </button>
              </nav>
              <button className="md:hidden text-gray-600 hover:text-gray-900">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>
          </header>
          <Drawer
            anchor={"left"} // Drawer opens from the left
            open={state}
            onClose={toggleDrawer(false)}
          >
        <div className='w-[500px]'>
          {navLocation==="dashboard" ?
      <PayChart apifeatch={apifeatch}/>
        :
<Form/>
        }
        </div>
          </Drawer>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
